export const upperFirst = (input: string) => input.charAt(0).toUpperCase() + input.slice(1);
